import React from "react";
import type { StyleRules, Theme, WithStyles } from "@material-ui/core";
import { Box, createStyles, Dialog, DialogContent, IconButton, Typography, withStyles } from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";

import { CloseOutlined as CloseOutlinedIcon } from "@eroad/icons/material";

const styles = (theme: Theme): StyleRules =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(8),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    subtitle: {
      fontSize: "12px",
      fontWeight: "bold" as const,
      textTransform: "uppercase" as const,
      color: "rgba(0, 0, 0, 0.54)",
    },
  });

interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  subtitle?: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps): React.ReactElement => {
  const { children, classes, subtitle, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      {subtitle && (
        <Typography variant="h6" className={classes.subtitle}>
          {subtitle}
        </Typography>
      )}
      <Typography variant="h4">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseOutlinedIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export interface SettingsProps {
  children?: React.ReactNode;
  show: boolean;
  title: string;
  subtitle?: string;

  minWidth?: string;
  onClose: () => void;
}

const SettingsDialog = ({ children, show, title, subtitle, onClose }: SettingsProps): JSX.Element => (
  <Dialog onClose={onClose} aria-labelledby="simple-dialog-title" open={show} fullWidth maxWidth="xs">
    <DialogTitle id="simple-dialog-title" subtitle={subtitle} onClose={onClose}>
      {title}
    </DialogTitle>
    <DialogContent>
      <Box p={4}>{children}</Box>
    </DialogContent>
  </Dialog>
);
export default SettingsDialog;
